import * as React from 'react';
import { useStore } from 'zustand';
import { CriteriaStoreContext } from '../context';

export const useCriteriaStoreMovePredicateToGroup = () => {
    const { store } = React.useContext(CriteriaStoreContext);
    if (!store) throw new Error('Missing CriteriaStoreContext.Provider in the tree');
    const movePredicateToGroup = useStore(store, (s) => s.movePredicateToGroup);

    return movePredicateToGroup;
};
